export function JsonCopy<T>(object: T) {
  return JSON.parse(JSON.stringify(object)) as T;
}
